import React, { useEffect, useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { useLocation, Link } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import useFetchAssessmentSection from "./useFetchAssessmentSection";
import AccordionComponent from "../../components/Common/Accordion";
import ListGroup from "../../components/Common/ListGroup";
import OptionsMenu from "../../components/Classroom/OptionsMenu";

const SimpleSidebar = ({ pages, questionSidebar }) => {
  const [heading, setHeading] = useState("");
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const assessmentId = pathnames[2];
  const sectionId = pathnames[3];
  const { state } = useAppContext();
  const { sections, error } = useFetchAssessmentSection(
    assessmentId,
    sectionId,
    questionSidebar
  );

  useEffect(() => {
    setHeading(state.sideBarHeading);
  }, [state]);

  const optionsMenuList = useMemo(
    () => [
      {
        text: "Edit",
        actionsHandler: () => {},
        imgSrc: "/editIcon.svg",
        imgAltText: "edit-icon",
      },
      {
        text: "Delete",
        actionsHandler: () => {},
        imgSrc: "/deleteIcon.svg",
        imgAltText: "delete-icon",
      },
    ],
    []
  );

  const questionsMenuList = useMemo(
    () => [
      {
        text: "Create Question",
        actionsHandler: null,
        imgSrc: "/editIcon.svg",
        imgAltText: "edit-icon",
      },
      {
        text: "Browse Question",
        actionsHandler: null,
        imgSrc: "/deleteIcon.svg",
        imgAltText: "delete-icon",
      },
    ],
    []
  );

  const truncateText = useCallback((text, maxLength) => {
    if (text?.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }, []);

  const renderMenuButton = useCallback((optionsMenuList, item) => {
    return <OptionsMenu optionsList={optionsMenuList} passedData={item._id} />;
  }, []);

  return (
    <div className="coursework-sidebar">
      <div className="coursework-heading">
        <h6>{heading}</h6>
      </div>
      <hr />
      <div>
        {!questionSidebar ? (
          <div className="coursework-content">
            <ul>
              {pages?.map((page) => (
                <li key={page.id}>
                  <Link
                    to={`${page.link}/${page?.slug ? pathnames[1] : ""}`}
                    className={
                      `${page.link}/${page?.slug ? pathnames[1] : ""}` ===
                      location.pathname
                        ? "active-link" // Add a CSS class for active link styling
                        : "inactive-link" // Add a CSS class for inactive link styling
                    }
                  >
                    {page.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          sections && (
            <AccordionComponent
              header={sections?.name}
              button={true}
              buttonText={null}
              btnImage="/Plus.svg"
              questionsMenuList={
                sections?.type === "Standard" ? questionsMenuList : null
              }
              className="my-3 py-0 px-2 w-100"
              sections={sections}
            >
              {sections?.questions?.map((item, index) => (
                <ListGroup
                  key={item._id} // Ensure unique key for each item
                  variant="flush"
                  index={index}
                  className="d-flex justify-content-between"
                >
                  <span> Q{index + 1}.</span>
                  <span>{truncateText(item?.statement, 10)}</span>
                  {renderMenuButton(optionsMenuList, item)}
                </ListGroup>
              ))}
            </AccordionComponent>
          )
        )}
      </div>
      {error && <p className="error-message">Error: {error}</p>}
    </div>
  );
};

SimpleSidebar.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })
  ).isRequired,
  questionSidebar: PropTypes.bool.isRequired,
};

export default SimpleSidebar;
